
<div class="card project-card marTB"  *ngIf="viewType !=='content'"  [ngClass]="status==false ? 'no-pointer' : ''" (click)="overviewData(this)">    
    <div class="project-card-logo-container">
      <div class="project-card-logo" *ngIf="!logo || logo === 'null'" [ngClass]="status==false ? 'bgColor' : '' ">
        <div class="project-card-logo-text">{{tabHeadingInitial(title)}}</div>
      </div>
      <div class="project-card-logo-image" *ngIf="logo && logo !== 'null'" [ngClass]="status==false ? 'bgColor' : '' ">
          <img class="img-circle"  [ngClass]="status==false ? 'opac-5' : '' " height="50px" width="50px" [src]="logo" alt=''>
      </div>     
    </div>
    <div >
        <img *ngIf="status==false" class="archive_icon" src="assets/images/icon_archive.png" >
    
    </div>
    <div class="header">
        <div class="left">
            <div class="title" [ngClass]="status==false ? 'opac-5' : '' ">{{title | truncate: 50 : "..."}}</div>
            <div class="subtitle1 fontWt300" [ngClass]="status==false ? ' opac-5' : '' ">{{extrainfo1}}</div>
        </div>
       
    </div>                                              
    <div class="content" >
        <p class="project-card-desc description" [ngClass]="status==false ? 'opac-3' : '' " > {{description | truncate: 124 : '...'}}</p>
        <ul class="project-bottom-icon marT11"  [ngClass]="textDir=='rtl'?'padR0':''">
            <li> 
                <img *ngIf="this.dataType != 'School'" class="pad_icon1" src="assets/images/icon_school_count.png" [ngClass]="status==false ? ' opac-25' : '' ">
                <img *ngIf="this.dataType == 'School'" class="pad_icon1" style="height: 17px;width: 16px;" src="assets/images/icon_student_count.png" [ngClass]="status==false ? ' opac-25' : '' ">

            </li>
            <li class="hgt_icon wid_ic" [ngClass]="status==false ? ' opac-5' : '' " [dir]="textDir">{{count}}</li>
	    <!--
            <li class="marL29 hgt_icon pad_icon2"[ngClass]="status==false ? ' opac-25' : '' " > <i class="icon icon-position"></i> </li> 
            <li class="hgt_icon" [ngClass]="status==false ? ' opac-5' : '' " > {{location | truncate: 30: '...'}}</li>
	    -->
            <li class=" hgt_icon pad_icon2" [ngClass]="status==false ? ' opac-25' : 'opac-5' "  > <i class="icon icon-position  padB4" [ngClass]="textDir=='ltr'?'marL29':'marR29'"></i> </li> 
            <li class="hgt_icon wid_ic" [ngClass]="status==false ? ' opac-5' : '' " > {{location | truncate: 30: '...'}}</li>
        </ul>
    </div>
</div>


<div class="card no-margin content-card marTB cur-def" *ngIf="viewType ==='content'"  [ngClass]="status==false ? 'no-pointer' : ''">    
    <div class="header">
      <div class="left content-card-header-left cur-def">
        <div class="title ver-center cur-poi" (click)="overviewData(this)" [ngClass]="status==false ? 'opac-5' : '' "><span class="cur-poi" >{{title | truncate: 50 : "..."}}</span></div>
      </div>
      <div class="content-card-logo-container cur-def">
          <img src="assets/images/document_icon_2x.png" style="height:36px;" *ngIf="dataType === 'document'">
          <img src="assets/images/video_icon_2x.png" style="height:36px;" *ngIf="dataType === 'video'">
          <img src="assets/images/audio_icon_2x.png" style="height:36px;" *ngIf="dataType === 'audio'">
          <img src="assets/images/url_icon_2x.png" style="height:36px;" *ngIf="dataType === 'link'">
        </div>   
    </div>      
                                        
    <div class="content no-padTop marT5">
      <label class="label-light line-hgt-14">{{description | truncate: 50 : '...'}}</label>
      <label class="label-light">{{subject}}</label>
      
      <div class="row spaceBtwn marT10">
        <div class="width90 padT5">
          <div class="flexStart">
            <div class="flexStart"><label><img src="assets/images/group-icon.PNG" width="18" height="14" style="margin-top: 3px;"></label><label class="line-hgt-20 padL5" [ngClass]="textDir=='rtl'?'padR5':''">{{extrainfo2}}</label></div>
            <div class="flexStart padL20 padT3"><div><i class="icon icon-language font17 padT5 padR5"></i></div><div ><label class="line-hgt-14" [ngClass]="textDir=='rtl'?'padR5':''">{{dataType | ucfirst}} in {{language}}</label></div></div> 
          </div>
        </div>
        <div class="padT3 cur-poi">
        <i class="icon icon-favorite-solid font22" [ngClass]="{'starGold':featured === true,'starGrey': featured === false}" (click)="toggleData(this)"></i>
        </div>
      </div>
    </div>
</div>